import * as S from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import { useAppSelector } from '../../../store';

const Loading = () => {
  const { loading } = useAppSelector((state) => state.load);

  return (
    <>
      {loading === '' ? (
        <></>
      ) : (
        <>
          <S.DivLoading>
            <FontAwesomeIcon icon={faCircleNotch} spin spinReverse speed={5} />
            <S.Texto>{loading}...</S.Texto>
          </S.DivLoading>
          <S.Loading></S.Loading>
        </>
      )}
    </>
  );
};

export default Loading;
